// extracted by mini-css-extract-plugin
export default {"customError":"AgreementInput_customError__sLBAb"};